
import { Component, Vue, Watch } from "vue-property-decorator";
import SetScore from "./step-view/set-score.vue";
import SetQuestion from "./step-view/set-question.vue";
import SetDimension from "./step-view/set-dimension.vue";
import SetOther from "./step-view/set-other.vue";
import AskGoOn from "./components/delete-dialog.vue";
import vuexStore from "@/store/vuex-store";
import {
  BeforeVideo,
  ExamV2Custom,
  StructExamScoreConfig,
  StructExamQuestionCommentConfig,
  StructExamDimensionConfig,
  StructExamQuestionConfig
} from "@/lib/model/exambuilder/exam-v2";
import Power from "@/views/paper/components/power.vue";
import AiStepBar from "@/components/layout/ai-builder-step.vue";
import { StructDimensionGroupConfig } from "@/lib/model/exambuilder/configGroup";
// import Config from "./config/config.vue";
import SetProgress from "@/views/ai-builder-component/step-view/set-progress.vue";
import { ExamComponent } from "@/lib/model/exambuilder/exam-component/exam";
import {
  Company,
  CompanySpecialConfigNew,
  Params,
  Vir
} from "@/lib/model/exambuilder/exam-component/company";
import { QuestionV2Object } from "@/lib/model/exambuilder/question-v2";
import SetAutoRule from "./step-view/set-auto-rule.vue";
import {
  HandDetection,
  HandForm
} from "@/lib/model/exambuilder/exam-component/component";

@Component({
  components: {
    SetProgress,
    SetScore,
    SetQuestion,
    SetDimension,
    SetOther,
    AskGoOn,
    Power,
    AiStepBar,
    // Config,
    SetAutoRule
  }
})
export default class AiBuilder extends Vue {
  pathText = "新建面试";
  stepShow: boolean[] = [false, false, false, false, false, false]; //五个步骤显隐
  currentStep = 0; //当前步骤 0 1 2 3
  vuexStores = vuexStore;
  examId = 0;
  paperId = 0;
  versionId: number | undefined = undefined;
  isEdit = false; //是否编辑页面
  dataInited = false;
  askGoOn = false; //是否继续上次的新建流程
  isCandidateUsed = false; //是否有候选人答题
  powerExamId = 0; //设置权限的面试id
  showPower = false;
  showCreateNew = false;
  showTips = false;
  virList: Vir[] = []; //虚拟人列表

  // 翻页限制速度，防止点击太快
  canChangePage = true;
  canCancelPage = true;
  pageInterval = 300;
  cancelInterval = 500;
  submitting = false;

  // 原始分数配置，如果有候选人答完题，则需要使用原始分数配置提交
  originScoreConfigList: StructExamScoreConfig[] | null = null;

  videoUrlDef =
    "https://vod.hina.com/a3309d04251940faa56806be59bdf122/8c7be05066f64d29ae74ffbd5500daa9-ca173c7e0f3241eb8285dedda051a1ba-ld.mp4"; //视频预览url默认
  descImgUrlDef =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png"; //须知语默认封面

  // 保存定时器，避免频繁写入数据
  saveDataTimer: number | null = null;

  exam: ExamV2Custom = new ExamV2Custom();
  examComponent: ExamComponent = new ExamComponent(); //页面所有数据源头，也是最终提交物
  askSubmit = false; //完成弹窗
  askCancel = false; //完成弹窗
  ask = {
    title: "",
    text: "",
    cancelBtn: "",
    okBtn: ""
  };

  companyPower = new CompanySpecialConfigNew(); //公司一些权限

  // 内部使用 设置web页
  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  // 来源
  get builder(): string {
    // return this.vuexStores.company.channelCode;
    return "";
  }

  preview() {
    const step4 = this.$refs.step4 as any;
    step4.createExperienceQrCode();
  }

  // 已有候选人 直接弹到第三步
  @Watch("isCandidateUsed")
  save(n: any, o: any) {
    if (n && this.currentStep < 2) {
      this.showCurrentStep(2);
    }
  }

  @Watch("exam.dimensionKeyList", { deep: true, immediate: true })
  onChange() {
    this.exam.examDimensionConfigList = this.exam.dimensionKeyList.reduce(
      (dimenConfigList, dimenKey) => {
        const dimen = this.exam.examDimensionConfigList.find(
          dimensionConfig => dimensionConfig.dimensionKey === dimenKey
        );
        if (dimen) {
          dimenConfigList.push(dimen);
        } else {
          dimenConfigList.push(new StructExamDimensionConfig(dimenKey));
        }
        return dimenConfigList;
      },
      [] as StructExamDimensionConfig[]
    );
  }

  //禁用上一步  已有候选人 不得进入1 2步。  r2追加：抽题组卷 不得进入 12步
  get disabledPre() {
    const r1 = this.isEdit && this.isCandidateUsed && this.currentStep === 2;
    // const r2 =
    //   this.isEdit &&
    //   this.exam.isRandomQuestions === 1 &&
    //   this.currentStep === 2;
    return r1;
  }

  async created() {
    this.loadCache();
    this.virList = await Vir.getList();

    this.dataInited = false;
    this.currentStep = 0;

    if (Number(this.$route?.query?.paperId)) {
      //编辑进入
      this.paperId = Number(this.$route.query.paperId);
      this.versionId = Number(this.$route.query.version);
      this.examId = Number(this.paperId);
      this.currentStep = Number(this.$route?.query?.step ?? 0);
      this.isEdit = true;
      this.pathText = "编辑面试";
      await this.getExam();
    } else {
      // 新建进入 有缓存 询问是否继续新建
      if (
        localStorage.getItem("ai-builder-cache-component") ||
        localStorage.getItem("ai-builder-cache-exam")
      ) {
        this.askGoOn = true;
      } else {
        //-无缓存 初始化
        this.newCreate();
      }
      this.dataInited = true;
    }

    // 进入url指定对应页面 默认0
    this.showCurrentStep(this.currentStep);
    this.vuexStores.updateAiStep({ show: true, step: this.currentStep });
    this.getCompanyPower();
  }

  // generateHandDetect() {
  //   const handConfig = new HandDetection();
  //   if (
  //     !this.examComponent.examVersionInfo.handDetection.configData
  //       .noticeMessageList.length
  //   ) {
  //     this.examComponent.examVersionInfo.handDetection.configData.noticeMessageList =
  //       handConfig.configData.noticeMessageList;
  //   }
  //   if (
  //     !this.examComponent.examVersionInfo.handDetection.configData
  //       .noArmCompleteConfigMessageList.length
  //   ) {
  //     this.examComponent.examVersionInfo.handDetection.configData.noArmCompleteConfigMessageList =
  //       handConfig.configData.noArmCompleteConfigMessageList;
  //   }
  // }

  // generateBodyDetect() {
  //   const bodyConfig = new BodyDetect();

  // }

  //获取面试信息
  async getExam(getInfo = true) {
    const res = await ExamComponent.get(this.examId, this.versionId);
    if (getInfo) {
      this.examComponent = new ExamComponent().assign(res);
      // this.generateHandDetect();
      // this.generateBodyDetect();
      await this.getParams();
      this.examComponent.examVersionInfo.allParams = this.examComponent.examVersionInfo.paramList;
      this.exam = ExamComponent.getExamV2(this.examComponent);
      const t = await this.getQuestionList();
      this.exam.questionSelectedList = t.list;
      this.examComponent.examVersionInfo.questionSelectedList = t.list;
      this.exam.setDefaultValue();
      this.originScoreConfigList = this.exam.examScoreConfigList;
      this.pathText = "编辑面试-" + this.exam.name;
    }

    // 如果url上带有forceUpdate=1，则无视候选人存在强制更新面试
    const forceUpdate = Number(this.$route.query.forceUpdate) == 1;
    this.isCandidateUsed = this.exam.isCandidateUsed === 1 && !forceUpdate;
    this.dataInited = true;
  }

  // 维度发生变化清空维度组配置
  resetDimensionGroup() {
    this.examComponent.examVersionInfo.dimensions.dimensionGroupList = [];
  }

  //更新已选题目list
  async getQuestionList() {
    const param = {
      questionIdList: this.exam?.questionIdList,
      dimensionKeyFilterList: this.exam?.dimensionKeyList
    };
    return await QuestionV2Object.get(param);
  }

  //公司权限
  getCompanyPower() {
    Company.get().then(res => {
      this.companyPower = res.companySpecialConfigNew;
      this.vuexStores.updateCompanyPower15(this.companyPower);
    });
  }

  //步骤控制
  showCurrentStep(index: number) {
    if (this.currentStep === 3 && index === 2) {
      console.log(this.examComponent, "测试组件");
      this.exam = ExamComponent.getExamV2(this.examComponent);
      console.log(this.exam, "测试组件1");
    } else if (this.currentStep === 2 && index === 3) {
      console.log(this.exam, "测试组件");
      this.examComponent = ExamComponent.resetDataByExamV2(
        this.examComponent,
        this.exam
      );
      console.log(this.examComponent, "测试组件1");
    }

    this.currentStep = index;
    this.vuexStores.updateAiStep({ show: true, step: index });
    //刷新保持当前页面 -更新url
    const urlParams = this.$route.query;
    if (!urlParams?.step) {
      //url加step
      window.history.pushState(
        "",
        "",
        this.$route.fullPath + "&step=" + this.currentStep
      );
    } else {
      //url更新step
      urlParams.step = String(this.currentStep);
      let p = ``;
      for (const i in urlParams) {
        p += `${i}=${urlParams[i]}&`;
      }
      window.history.pushState(
        "",
        "",
        this.$route.path + "?" + p.substring(0, p.length - 1)
      );
    }
    this.stepShow.forEach((item: boolean, i: number) => {
      if (index === i) {
        this.$set(this.stepShow, i, true);
      } else {
        this.$set(this.stepShow, i, false);
      }
    });
  }

  //取消
  cancel() {
    if (!this.canChangePage) return;

    this.ask = {
      title: `提示`,
      text: "您做的修改尚未保存，确定退出吗？",
      cancelBtn: "取消",
      okBtn: "退出"
    };

    this.askCancel = true;
  }

  checkHasCandidateUsed() {
    // 已有候选人答题时不可更改分数
    if (this.exam.isCandidateUsed && this.originScoreConfigList) {
      this.exam.examScoreConfigList = this.originScoreConfigList;
    }
  }

  get forceEdit(): boolean {
    return Boolean(this.$route?.query?.forceEdit) || false;
  }

  // beforeSubmitFormatData() {
  //   // 没有维度组走默认配置
  //   const dimensionGroupList = this.examComponent.examVersionInfo.dimensions
  //     .dimensionGroupList;
  //   if (dimensionGroupList.length === 0) {
  //     const dimensionConfigList = this.examComponent.examVersionInfo.dimensions
  //       .dimensionConfigList;
  //     const dimensionGroup = DimensionGroup.getDefaultDimensionGroup(
  //       dimensionConfigList
  //     );
  //     dimensionGroupList.push(dimensionGroup);
  //   }
  // }
  showChannelTips = false;
  showChannelTipsResolve: (value?: unknown) => void = () => null;
  showChannelTipsReject: (reason?: any) => void = () => null;
  // 提交二次确认
  beforeSubmitAsk() {
    this.ask = {
      title: `提示`,
      text:
        "如继续保存，当前面试间后续将无法在渠道页面中编辑高级设置，请确认是否继续？",
      cancelBtn: "取消",
      okBtn: "确认"
    };
    this.showChannelTips = true;
    return new Promise((resolve, reject) => {
      this.showChannelTipsResolve = resolve;
      this.showChannelTipsReject = reject;
    });
  }
  showChannelTipsOk() {
    this.showChannelTips = false;
    this.showChannelTipsResolve(true);
  }
  showChannelTipsCancel() {
    this.showChannelTips = false;
    this.showChannelTipsReject();
  }

  //完成
  async submit() {
    if (this.submitting) return;
    this.submitting = true;
    try {
      // 10 11 是渠道创建的面试 需二次确认
      if ([10, 11].includes(this.examComponent.examInfo.examCreatedType)) {
        const checkResult = await this.beforeSubmitAsk();
        if (!checkResult) return;
      }

      const result = (this.$refs.step5 as any).checkData();
      if (!result) return;
      // this.beforeSubmitFormatData();
      console.log(
        "🐶🐶 ~ AiBuilder ~ submit ~ this.examComponent:",
        this.examComponent
      );
      const res = await this.checkRules();
      if (!res) return;
      await this.send();
    } finally {
      this.submitting = false;
    }
  }

  async mokaSubmit() {
    if (this.submitting) return;
    this.submitting = true;
    try {
      const checkRulesRes = await this.checkRules(); // 不同的校验
      if (!checkRulesRes) return;

      const method = !this.isEdit ? "create" : "update";
      const res = await ExamComponent[method](this.examComponent);

      if (res.code !== 0) return;

      this.mokaBack();
    } finally {
      this.submitting = false;
    }
  }

  async send(newBatch = false) {
    const method = !this.isEdit
      ? "create"
      : newBatch
      ? "createNewVersion"
      : "update";
    const res = await ExamComponent[method](this.examComponent);
    if (res.code !== 0) return;
    if (this.isEdit) {
      this.showAskPower(this.examComponent.metaInfo.examId);
    } else {
      this.showAskPower(res.data.examId);
    }
  }

  async checkRules() {
    if (this.isEdit) {
      const { data } = await ExamComponent.checkUpdate({
        examId: this.examComponent.metaInfo.examId,
        examVersionId: this.examComponent.metaInfo.examVersionId,
        examInfo: this.examComponent.examInfo,
        examVersionInfo: this.examComponent.examVersionInfo
      });
      if (data.curExamVersionHasCandidate) {
        if (data.updateAnswerProcess) {
          this.showCreateNewDialog();
          return false;
        } else if (data.updateMakeScore) {
          this.showTipsDialog();
          return false;
        }
      }
    }
    return true;
  }

  showCreateNewDialog() {
    this.ask = {
      title: "提示",
      text: "检测到您修改了面试内容，确定新建批次吗",
      okBtn: "确定",
      cancelBtn: "取消"
    };
    this.showCreateNew = true;
  }

  showTipsDialog() {
    this.ask = {
      title: "提示",
      text: `
      <div style="margin-bottom: 10px;">检测到您修改了面试的规则，请选择保存方式</div>
      <div style="display:flex;background: rgba(230, 58, 14, 0.06);padding: 12px;font-weight: 400;font-size: 14px;color: #101017;line-height: 22px;border-radius: 4px;margin-bottom: 20px;">
        <div style="width: 70px;">注：</div>
        <div>
          <div style="margin-bottom: 10px;">请根据实际需要谨慎选择保存方式</div>
          <div style="margin-bottom: 10px;">保存原面试不会产生新批次，建议对之前候选人采取重跑动作以保证批次内</div>
          <div>另存新批次会导致面试下出现新的批次，旧批次中的候选人及配置不会收到影响</div>
        </div>
      </div>
      `,
      okBtn: "另存新批次",
      cancelBtn: "保存原面试"
    };
    this.showTips = true;
  }

  handleCreateNew() {
    this.send(true);
    this.showCreateNew = false;
  }

  handleShowTips(bool: boolean) {
    this.showTips = false;
    this.showSecondTipsDialog(bool);
  }

  // 选择保存原面试和另存新批次的二次弹框确认
  // bool: true 另存新批次，false保存原面试
  showSecondTips = false;
  newBatchVersion = false; // 是否另存新批次
  showSecondTipsDialog(bool: boolean) {
    if (bool) {
      this.ask = {
        title: "提示",
        text: `
        <div style="text-align: center;margin-bottom: 10px;">当前选择另存新批次</div>
        <div style="background: rgba(230, 58, 14, 0.06);padding: 12px;font-weight: 400;font-size: 14px;color: #101017;line-height: 22px;border-radius: 4px;margin-bottom: 20px;">
          <div style="margin-bottom: 10px;">另存新批次会导致面试下出现新的批次，旧批次中的候选人及配置不会收到影响</div>
          <div>点击"确认"后，本操作不可撤销，请谨慎选择！</div>
        </div>
        `,
        okBtn: "确认",
        cancelBtn: "取消"
      };
      this.newBatchVersion = true;
    } else {
      this.ask = {
        title: "提示",
        text: `
        <div style="text-align: center;margin-bottom: 10px;">当前选择保存原面试</div>
        <div style="background: rgba(230, 58, 14, 0.06);padding: 12px;font-weight: 400;font-size: 14px;color: #101017;line-height: 22px;border-radius: 4px;margin-bottom: 20px;">
          <div style="margin-bottom: 10px;">保存原面试不会产生新批次，建议对之前候选人采取重跑动作以保证批次内</div>
          <div>点击"确认"后，本操作不可撤销，请谨慎选择！</div>
        </div>
        `,
        okBtn: "确认",
        cancelBtn: "取消"
      };
      this.newBatchVersion = false;
    }
    this.showSecondTips = true;
  }
  handleShowSecondTipsOk() {
    this.send(this.newBatchVersion);
    this.showSecondTips = false;
  }

  //询问是否编辑权限
  showAskPower(examId: number) {
    this.ask = {
      title: `${this.isEdit ? "编辑" : "保存"}成功`,
      text: `面试已${
        this.isEdit ? "编辑" : "保存"
      }成功，系统生成题目视频、面试引导视频等需要一定时间，请等待5分钟后扫码参加面试`,
      okBtn: "确定",
      cancelBtn: "返回面试列表"
    };
    this.powerExamId = examId;
    this.askSubmit = true;
    if (!this.isEdit) {
      //新建后 清掉缓存
      this.clearCache();
    }
  }

  //面试权限弹窗
  toPower() {
    //
    this.showPower = true;
  }

  //上一步
  async pre() {
    if (!this.canChangePage) return;
    this.beforePageChange();
    if (this.currentStep === 0) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 1) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 2) {
      //todo 进行对应页面离开前的数据校验
    }
    if (this.currentStep === 3) {
      const checkDataResult = await (this.$refs[
        "step" + (this.currentStep + 1)
      ] as any)?.checkData();

      if (!checkDataResult) return;
    }
    this.showCurrentStep(this.currentStep - 1);
    if (this.isEdit) {
      this.getExam(false); //获取是否有人答题
    }
  }

  //完成步骤5
  finishStep4() {
    this.exam.examId = this.paperId;
    //视频默认特判
    this.exam.publicityPageVideoUrl =
      this.exam.publicityPageVideoUseWhich === 1
        ? this.videoUrlDef
        : this.exam.publicityPageVideoUrl;
    //须知语封面默认特判
    if (this.exam.descAfterShowWay === 1) {
      this.exam.descAfterShowWayImgUrl = this.descImgUrlDef;
    }

    //过滤富文本figure标签本身 (页面loading中 富文本编译器已销毁 不影响结果)
    this.exam.publicityPageContent = this.exam.publicityPageContent
      .replace(/<figure[^>]*>/g, "")
      .replace(/<\/figure>/g, "");

    this.exam.examVideoList.forEach((it: BeforeVideo) => {
      it.text = it.text
        .replace(/<figure[^>]*>/g, "")
        .replace(/<\/figure>/g, "");
    });

    // 处理评价规则
    this.exam.examQuestionConfigList = this.exam.examQuestionConfigList.reduce(
      (
        pre: StructExamQuestionConfig[],
        questionConfig: StructExamQuestionConfig
      ) => {
        if (questionConfig.questionId) {
          questionConfig.commentConfigList = questionConfig.commentConfigList.reduce(
            (pre, cur) => {
              if (cur.comment.length) {
                pre.push(cur);
              }
              return pre;
            },
            [] as StructExamQuestionCommentConfig[]
          );
          pre.push(questionConfig);
        }
        return pre;
      },
      [] as StructExamQuestionConfig[]
    );
    // 处理追问配置
    this.exam.examDimensionConfigList = this.exam.examDimensionConfigList.reduce(
      (pre, dimension) => {
        if (dimension.dimensionKey) {
          pre.push(dimension);
        }
        return pre;
      },
      [] as StructExamDimensionConfig[]
    );
    this.exam.dimensionGroupConfigList = this.exam.dimensionGroupConfigList.reduce(
      (pre, cur: StructDimensionGroupConfig) => {
        if (cur.groupName) {
          pre.push(cur);
        }
        return pre;
      },
      [] as StructDimensionGroupConfig[]
    );
  }

  //下一步
  async next() {
    if (!this.canChangePage) return;
    this.beforePageChange();
    const checkDataResult = await (this.$refs[
      "step" + (this.currentStep + 1)
    ] as any)?.checkData();

    if (!checkDataResult) return;

    this._next();
    if (this.isEdit) {
      await this.getExam(false); //获取是否有人答题
      this.checkHasCandidateUsed();
    }
  }

  // 防止点太快
  beforePageChange() {
    this.canChangePage = false;
    this.canCancelPage = false;
    setTimeout(() => {
      this.canChangePage = true;
    }, this.pageInterval);
    setTimeout(() => {
      this.canCancelPage = true;
    }, this.cancelInterval);
  }

  // 不检查直接下一步
  _next() {
    this.showCurrentStep(this.currentStep + 1);
  }

  back() {
    const value = localStorage.getItem("ai-builder-cache-component");
    const valueExam = localStorage.getItem("ai-builder-cache-exam");

    if (this.isEdit || value || valueExam) {
      this.cancel();
      return;
    }

    this.clearCache();
    this.$router.push("/exam-component/paper");
  }

  mokaBack() {
    return window.history.back();
  }

  destroyed() {
    console.log("离开");
    this.vuexStores.updateAiStep({ show: false, step: 0 });
  }

  getInfo(info: any, type?: string) {
    let temp: any;
    if (type === "tag") {
      temp =
        this.exam.applicationRuleList?.filter(
          (el: any) => el.type === "级联面试分配"
        ) || [];
      temp.push(...info);
    } else {
      // 集联
      temp =
        this.exam.applicationRuleList?.filter(
          (el: any) => el.type !== "级联面试分配"
        ) || [];
      temp.push(...info);
    }
    this.exam.applicationRuleList = temp;
    console.log(this.exam.applicationRuleList);
    // if (this.exam.applicationRuleList && Array.isArray(this.exam.applicationRuleList)) {
    //   for (let i = 0; i < this.exam.applicationRuleList.length; i++) {
    //     const el = this.exam.applicationRuleList[i];
    //     for (let j = 0; j < info.length; j++) {
    //       const item = info[j];
    //       if (el.applicationRuleId === item.applicationRuleId)
    //     }
    //   }
    // } else {
    //   this.exam.applicationRuleList = info;
    // }
  }

  // 保存缓存
  saveCache() {
    // 编辑面试不需要保存缓存
    if (this.isEdit || this.submitting) return;

    //延迟缓存，以免自动分配分数时频繁IO
    if (this.saveDataTimer) clearTimeout(this.saveDataTimer);

    this.saveDataTimer = setTimeout(() => {
      this.saveDataTimer = null;
      // this.examComponent = ExamComponent.resetDataByExamV2(
      //   this.examComponent,
      //   this.exam
      // );
      localStorage.setItem(
        "ai-builder-cache-component",
        JSON.stringify(this.examComponent)
      );
      localStorage.setItem("ai-builder-cache-exam", JSON.stringify(this.exam));
    }, 500);
  }

  loadCache() {
    const cacheJson = localStorage.getItem("ai-builder-cache-component");
    const cacheExam = localStorage.getItem("ai-builder-cache-exam");

    if (cacheJson) {
      this.examComponent = new ExamComponent().assign(JSON.parse(cacheJson));
    }
    if (cacheExam) {
      this.exam = new ExamV2Custom().assign(JSON.parse(cacheExam));
    }
  }

  clearCache() {
    localStorage.removeItem("ai-builder-cache-component");
    localStorage.removeItem("ai-builder-cache-exam");
  }

  goOn() {
    this.askGoOn = false;
  }

  //重新创建
  async getParams() {
    const res = await Params.get();
    this.examComponent.examVersionInfo.defaultParams = res.paramList;
  }

  async newCreate() {
    this.clearCache();
    this.exam = new ExamV2Custom();
    this.examComponent = new ExamComponent();

    // 字段初始化
    await this.getParams();
    this.examComponent.examVersionInfo.allParams = this.examComponent.examVersionInfo.defaultParams;
    this.examComponent.examVersionInfo.applicationRule.assign({
      autoAuditList: [],
      customList: []
    });
    this.exam.examVideoList = [];
    this.exam.colorConfig.type = 2;
    this.$set(this.stepShow, 0, false);
    this.$nextTick(() => {
      this.$set(this.stepShow, 0, true);
    });
    this.askGoOn = false;
  }
  // 创建后提示弹窗
  submitOk() {
    this.$router.push("/exam-component/paper");
  }

  //取消后提示弹窗
  cancelOk() {
    if (!this.isEdit) {
      //新建 取消会清缓存
      this.clearCache();
    }

    this.$router.push("/exam-component/paper");
  }
}
